// src/pages/AttendeeTable.js
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchAttendees } from "store/attendeeSlice";

const AttendeeTable = () => {
  const { id } = useParams(); 
  const dispatch = useDispatch();
  const { items, loading, error, count } = useSelector(
    (state) => state.attendees
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchAttendees(id));
    }
  }, [dispatch, id]);

  return (
    <div
  className={
    "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white"
  }
>
  {/* Header */}
  <div className="rounded-t mb-0 px-4 py-3 border-0">
    <div className="flex flex-wrap items-center">
      <div className="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3 className="font-semibold text-lg text-blueGray-700">
          Attendees for Webinar #{id} ({count})
        </h3>
      </div>
    </div>
  </div>

  {/* Table */}
  <div className="block w-full overflow-x-auto">
    <table className="items-center w-full bg-transparent border-collapse">
      <thead>
        <tr>
          {["ID","Name","Email","Phone","Payment Status","Order ID","Registered At"].map((heading, idx) => (
            <th
              key={idx}
              className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
            >
              {heading}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan="7" className="text-center p-4">
              Loading attendees...
            </td>
          </tr>
        ) : error ? (
          <tr>
            <td colSpan="7" className="text-center p-4 text-red-500">
              {error}
            </td>
          </tr>
        ) : items.length > 0 ? (
          items.map((attendee) => (
            <tr key={attendee.id}>
              <td className="border-t-0 px-6 py-4 text-sm">{attendee.id}</td>
              <td className="border-t-0 px-6 py-4 text-sm">{attendee.attendee_name}</td>
              <td className="border-t-0 px-6 py-4 text-sm">{attendee.attendee_email}</td>
              <td className="border-t-0 px-6 py-4 text-sm">{attendee.guest_phone}</td>
              <td
                className={`border-t-0 px-6 py-4 text-sm font-semibold ${
                  attendee.payment_status === "success"
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                {attendee.payment_status}
              </td>
              <td className="border-t-0 px-6 py-4 text-sm">{attendee.razorpay_order_id}</td>
              <td className="border-t-0 px-6 py-4 text-sm">
                {new Date(attendee.registered_at).toLocaleString()}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="7" className="text-center p-4 text-gray-500 italic">
              No attendees found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>

  );
};

export default AttendeeTable;
